import { render } from "./App.vue?vue&type=template&id=12eeb0d2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=12eeb0d2&lang=css"

import exportComponent from "/home/runner/work/TIMS-APP/TIMS-APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__